jQuery_T4NT(document).ready(function($) {
     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

    $(".main-category__product").on("change", function() {
      var selectedProductItem = $(this).val();
      $("select[data-label='Select " + selectedProductItem + "']").show();
    });

    // MEGA MENU PRODUCT CATEGORY IMAGES HIDE AND SHOW
    $(".type_mn_link .t4s-menu-item").on("mouseover", function () {
      // Hide all image items
      $(".product_category--images .image-item").hide();
  
      // Get the text of the hovered menu item, trimmed of whitespace
      var menuItem = $(this).find("a").text().trim(); 
      console.log(menuItem);

      // Check if menuItem is "custom order"
      if (menuItem === "Custom Order") {
        console.log("menuItem is 'custom order', skipping render.");
        return; // Exit the function if it's "custom order"
      }

      // Show the corresponding image item
      if(menuItem) {
        $(`.product_category--images .image-item[data-category-item="${menuItem}"]`).show();
      } else {
        console.log("menuItem is not found");
      }
    });
});


